import type { SortingState } from '@tanstack/react-table';

/**
 * Maps table column ids to the API's allowlisted sort fields (dot paths for relations). A column can
 * map to several fields, e.g. a Name column to `['firstName', 'lastName']`; all use its direction.
 */
export type SortFieldMap = Readonly<Record<string, string | readonly string[]>>;

/**
 * Converts table sorting state to an API `sort` param, e.g. "title:asc,materialDetail.category:desc".
 * Columns missing from `fieldMap` are dropped, so only fields the API allows are ever sent.
 */
export function toSortParam(sorting: SortingState, fieldMap: SortFieldMap): string | undefined {
	const parts = sorting.flatMap(({ id, desc }) => {
		const fields = fieldMap[id] ?? [];
		return (typeof fields === 'string' ? [fields] : fields).map((field) => `${field}:${desc ? 'desc' : 'asc'}`);
	});
	return parts.length ? parts.join(',') : undefined;
}
